// src/context/ModerationWindowDatesContext.js
import React, { createContext, useContext, useState } from "react";

import { useApi } from "./ApiClient";

const ModerationWindowDatesContext = createContext();

export function ModerationWindowDatesProvider({ children }) {
//   { [sessionId]: { dates: [], loading: false, error: null } }
  const [datesCache, setDatesCache] = useState({});
   const api = useApi(process.env.REACT_APP_VAF_BASE_URL);

  // This function can be used by any consumer to "ensure dates are loaded"
  const fetchPreferredDates = async (sessionId) => {
    if (!sessionId || datesCache[sessionId]?.dates) return; // already loaded or invalid
    setDatesCache(prev => ({
      ...prev,
      [sessionId]: { dates: [], loading: true, error: null }
    }));

    try {
      const { data: response } = await api.get(
        `getPreferredDates?session_id=${sessionId}`
      );
      setDatesCache(prev => ({
        ...prev,
        [sessionId]: {
          dates: Array.isArray(response.data)
            ? response.data.map(d => d.lookupDate)
            : [],
          loading: false,
          error: null,
        }
      }));
    } catch (error) {
      setDatesCache(prev => ({
        ...prev,
        [sessionId]: {
          dates: [],
          loading: false,
          error: error?.response?.data?.message || 'Failed to fetch dates',
        }
      }));
    }
  };

  return (
    <ModerationWindowDatesContext.Provider value={{ datesCache, fetchPreferredDates }}>
      {children}
    </ModerationWindowDatesContext.Provider>
  );
}

export function useModerationWindowDates() {
  return useContext(ModerationWindowDatesContext);
}
